import { scanabilityToDisplay } from "../photo/labels";

type Props = {
  label: string;
  bankingSafe: boolean;
  onRepair?: () => void;
};

/** Ba trạng thái quét theo docs/71-consumer-ux.md §7 — chỉ chữ, không số, không mã lỗi kỹ thuật. */
export default function ScanabilityBadge({ label, bankingSafe, onRepair }: Props) {
  const display = scanabilityToDisplay(label, bankingSafe);
  return (
    <div className={`scanability-badge scanability-${display.tone}`} role="status">
      <span className="scanability-badge-title">
        {display.tone === "good" ? "✓ " : display.tone === "warn" ? "⚠ " : "✕ "}
        {display.title}
      </span>
      {display.showRepairAction && onRepair ? (
        <button type="button" className="btn btn-secondary" onClick={onRepair}>
          Sửa giúp tôi
        </button>
      ) : null}
    </div>
  );
}
